export const loginStrings = {
  appName: 'Rezeta',
  appTagline: 'Un solo sistema, todos tus centros.',
  title: 'Bienvenido a Rezeta',
  subtitle: 'Inicia sesión para continuar',
  fieldEmail: 'Correo electrónico',
  fieldEmailPlaceholder: 'doctor@ejemplo.com',
  fieldPassword: 'Contraseña',
  fieldPasswordPlaceholder: '••••••••',
  submit: 'Iniciar sesión',
  submitting: 'Iniciando sesión...',
  mfaTitle: 'Verificación en dos pasos',
  mfaSubtitle: 'Ingresa el código de tu aplicación de autenticación.',
  mfaFieldCode: 'Código de verificación',
  mfaFieldCodePlaceholder: '123456',
  mfaSubmit: 'Verificar',
  mfaSubmitting: 'Verificando...',
  mfaBackToLogin: 'Volver a iniciar sesión',
  continueWithGoogle: 'Continuar con Google',
  continueWithSso: (name: string) => `Continuar con ${name}`,
  orDivider: 'o',
} as const
